import React, { useEffect, useState } from 'react';
import { Image, ScrollView, StyleSheet, useWindowDimensions } from 'react-native';
import promocaoApi from '../../apis/promocaoApi';
import Promocao from '../../shared/entity/Promocao';
import { SIDE_PADDING } from '../../constants';
import Touchable from '../Generic/Touchable';
import { useNavigation } from '@react-navigation/native';
import midiaApi from '../../apis/midiaApi';

type Props = {};

const ListaPromocoes: React.FC<Props> = (props) => {
  const {} = props;

  const [promocoes, setPromocoes] = useState<Promocao[]>([]);
  const [temImagem, setTemImagem] = useState(false);
  const size = useWindowDimensions();
  const navigation = useNavigation();

  const getPromocoes = async () => {
    try {
      const res = await promocaoApi.getMany({ where: { ativo: true } });
      console.log('prmo', res);
      setPromocoes(res);
    } catch (err) {
      console.log('err', err);
    }
  };

  useEffect(() => {
    getPromocoes();
  }, []);

  useEffect(() => {
    for (let i = 0; i < promocoes.length; i++) {
      if (promocoes[i].urlBanner && promocoes[i].urlBanner !== '') {
        setTemImagem(true);
        return;
      }
    }
  }, [promocoes]);

  const goToPromocao = (id: number) => {
    navigation.navigate('PromocaoPage', { promocaoId: id });
  };

  if (promocoes.length === 0) {
    return null;
  }

  if (!temImagem) {
    return null;
  }

  // if (promocoes.length === 1) {
  //   return (
  //     <Touchable
  //       style={[{ width: size.width }, styles.divScroll]}
  //       onPress={() => goToPromocao(promocoes[0].id)}
  //     >
  //       <Image source={{ uri: midiaApi.getMidia(promocoes[0].urlBanner) }} style={styles.image} />
  //     </Touchable>
  //   );
  // }

  return (
    <ScrollView
      horizontal
      pagingEnabled
      showsHorizontalScrollIndicator={false}
      style={{ top: -10 }}
    >
      {promocoes.map((promocao) => (
        <Touchable
          key={promocao.id}
          style={[{ width: Math.min(size.width, 696) }, styles.divScroll]}
          onPress={() => goToPromocao(promocao.id)}
        >
          <Image source={{ uri: midiaApi.getMidia(promocao.urlBanner) }} style={styles.image} />
        </Touchable>
      ))}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  divScroll: {
    height: 150,
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    overflow: 'hidden'
  },
  image: { height: 150, resizeMode: 'contain', borderRadius: 7 }
});

export default ListaPromocoes;
